import _typeof from "@babel/runtime/helpers/esm/typeof";
import classnames from 'classnames';
import * as React from 'react';
import Button from '../button';
import { EmptyPagePrefix } from '../style/componentPrefix';
import { emptyConfig, getEmptyPageConfigByType, prefersDarkMode } from './config';
import './style/index';
var Empty = /*#__PURE__*/React.memo(function (props) {
  var defaultType = 'noContent';
  var className = props.className,
    type = props.type,
    title = props.title,
    action = props.action,
    desc = props.desc,
    img = props.img,
    imageStyle = props.imageStyle,
    children = props.children;
  var emptyPageConfig = getEmptyPageConfigByType(emptyConfig, type || defaultType);
  var renderImg = function renderImg() {
    var imgSrc;
    if (img) {
      if (_typeof(img) === 'object') {
        if (prefersDarkMode() && img.dark) {
          imgSrc = img.dark;
        } else {
          imgSrc = img.light;
        }
      } else {
        imgSrc = img;
      }
    } else {
      imgSrc = img === undefined ? emptyPageConfig.imgSrc : '';
    }
    return imgSrc ? ( /*#__PURE__*/React.createElement("img", {
      className: "".concat(EmptyPagePrefix, "-image"),
      src: imgSrc,
      style: imageStyle
    })) : null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(EmptyPagePrefix, className)
  }, renderImg(), /*#__PURE__*/React.createElement("div", {
    className: "".concat(EmptyPagePrefix, "-main-title")
  }, title !== undefined ? title : emptyPageConfig.title), (desc || emptyPageConfig.desc) && ( /*#__PURE__*/React.createElement("p", {
    className: "".concat(EmptyPagePrefix, "-sub-title")
  }, desc !== undefined ? desc : emptyPageConfig.desc)), (children || action) && ( /*#__PURE__*/React.createElement("div", {
    className: "".concat(EmptyPagePrefix, "-footer")
  }, children || action && ( /*#__PURE__*/React.createElement(Button, {
    type: action.type || 'primary',
    size: "middle",
    onClick: action.onClick,
    className: "".concat(EmptyPagePrefix, "-button")
  }, action.text || emptyPageConfig.btnName)))));
});
export default Empty;